import React from 'react';
import {Container} from 'semantic-ui-react';
import {db} from '../../../firebase'
import { Grid } from 'semantic-ui-react';
import { Box } from '@mui/material';
import { useSelector} from 'react-redux';
import { format } from 'date-fns';
import {
  Card,
  CardHeader,

} from '@mui/material';
import { NavLink } from 'react-router-dom';

const Tablero = (props) => {
const userUid = useSelector(store => store.usuario.user.uid);
const [allOrders,setAllOrders] = React.useState([])
const [userOrders,setUserOrders] = React.useState([])
const translateState = {
  'C0E':'Esperando Confirmacion',
  'C01':'Programado para retiro',
  'C02':'Programado para retiro',
  'C03':'Programado para retiro',
  'R01':'En ruta de entrega',
  'R02':'En ruta de entrega',
  'R03':'En ruta de entrega',
  'R04':'En ruta de entrega',
  'R05':'Entregado',
  'R06':'Entregado',
  'CA1':'No se logro entregar',
  'CA2':'No se logro entregar',
  'CA3':'No se logro entregar',
  'CA4':'No se logro entregar',
  }
  const styleState = {
    'C0E':'alert alert-primary',
    'C01':'alert alert-info',
    'C02':'alert alert-info',
    'C03':'alert alert-info',
    'R01':'alert alert-success',
    'R02':'alert alert-success',
    'R03':'alert alert-success',
    'R04':'alert alert-success',
    'R05':'alert alert-success',
    'R06':'alert alert-success',
    'CA1':'alert alert-danger',
    'CA2':'alert alert-danger',
    'CA3':'alert alert-danger',
    'CA4':'alert alert-danger',
    }

React.useEffect(()=>{
    const findOrdesrDispacht = async (userUid) =>{
   //   console.log(userUid)
      try {
        const ordesrDispacht = await db.collection(`${process.env.REACT_APP_COL_ORDERS}`).get()
        //  console.log(ordesrDispacht.docs)
          const Ordenes = ordesrDispacht.docs.map(doc => ({id: doc.id, ...doc.data()}))
          setAllOrders(Ordenes)
          const ordersPropietary = Ordenes.filter(item => item.originPropietary === userUid)
        //  console.log(ordersPropietary)
          ordersPropietary.sort((a, b) => (a.dispachtDate < b.dispachtDate)?1:-1) ;


          setUserOrders(ordersPropietary)
     
      } catch (error) {
  
        console.log(error)
      }

    }
    //setOrigenEmail(userEmail)
    findOrdesrDispacht(userUid)
  },[])


  // const filterUserOrders = (userUid) =>{           
  
  // }

  // filterUserOrders(userUid)

  return (  

    <Grid>
    <Container className='dashcontent'>
     <div>
     <h1>Última Actividad</h1>
    </div>
       <Grid.Row >
         <Grid.Column computer={8} mobile={16} tablet={16} className="dash-container-colmun ">
        
            <Card  className="card-ultimasOrdenes typeMiniforms">
              <CardHeader title="Últimas Solicitudes" />

                <Box sx={{ minWidth: 800 }}>
                <table className="table">
                      <thead>
                      <tr>
                      <th scope="col">Código</th>
                      <th scope="col">Cliente Destino</th>
                      <th scope="col">Fecha de envío</th>
                      <th scope="col">Estatus</th>
                      <th scope="col">Acción</th>
                      </tr>
                      </thead>
                      <tbody>

                      {userOrders.map((element) => (
                          <tr key={element.id}>
                          <td >{element.dispachtCode}</td>
                          <td >{element.originUserName}</td>
                          <td >{format(element.dispachtDate, 'dd/MM/yy')}</td>
                          <td ><span className={styleState[element.dispachtCurrentStatus]}>{translateState[element.dispachtCurrentStatus]}</span></td>
                          <td ><NavLink to={{
                          pathname: `/dashboard/dispatch/details/${element.id}`}} element={element} color="primary" variant="contained"> VER </NavLink></td>
                          </tr>
                          ))                          
                      }

                      </tbody>
                    </table>
              </Box>
            </Card>
         </Grid.Column>

         <Grid.Column computer={6} mobile={16} tablet={16} className="dash-container-colmun">
         {/* <LatestProducts  /> */}
         </Grid.Column>
    </Grid.Row>
    </Container> 
    </Grid>

   
    ); 
  };

export default Tablero;
